export default "__VITE_ASSET__WdSnf8sj__"